import { Tool } from './tool';

export class IsoscelesTriangle extends Tool {
  private drawing = false;
  private mouseMoved = false;
  private startingPoint!: { x: number; y: number };

  onMouseDown(e: MouseEvent | TouchEvent): void {
    if (this.isLocked) {
      return;
    }
    const { x, y } = this.getMousePosition(e);
    this.startingPoint = { x, y };
    this.drawing = true;
    this.mouseMoved = false;
    this.updateCtxStyle(this.animCtx);
    this.clearCtx(this.animCtx);
  }

  onMouseMove(e: MouseEvent | TouchEvent): void {
    if (!this.isLocked && this.drawing) {
      this.mouseMoved = true;
      const { x: startX, y: startY } = this.startingPoint;
      const { x: endX, y: endY } = this.getMousePosition(e);
      this.clearCtx(this.animCtx);
      this.drawTriangle(this.animCtx, startX, startY, endX, endY);
    }
  }

  onMouseUp(e: MouseEvent | TouchEvent): void {
    if (!this.isLocked && this.drawing) {
      this.drawing = false;
      if (this.mouseMoved) {
        const { x: startX, y: startY } = this.startingPoint;
        const { x: endX, y: endY } = this.getMousePosition(e);
        this.clearCtx(this.animCtx);
        this.drawTriangle(this.mainCtx, startX, startY, endX, endY);
        this.updateState();
      }
      this.mouseMoved = false;
    }
  }

  drawTriangle(
    ctx: CanvasRenderingContext2D,
    startX: number,
    startY: number,
    endX: number,
    endY: number
  ): void {
    this.updateCtxStyle(ctx);
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo((endX + startX) / 2, endY);
    ctx.lineTo(endX, startY);
    ctx.closePath();
    ctx.stroke();
  }
}
